

export enum IndeedCampaignStatus {
    Active = 1,
    Deleted = 2,
    Paused = 3
}
